<template>
  <v-container>
    <v-card height="calc(100vh - 110px)">
      <v-row no-gutter style="height: 100%">
        <!-- Lista de subtipos -->
        <v-col style="max-width: 300px">
          <v-btn
            exact
            icon
            class="mr-4"
            @click="
              $router.push({
                name: 'leads_requested_documents_types_by_lead_subtype',
              })
            "
          >
            <v-icon left>mdi-arrow-left</v-icon>
          </v-btn>
          <v-list>
            <v-list style="max-height: calc(100vh - 195px); overflow-y: auto">
              <template v-for="subtype in data">
                <v-list-item
                  :key="subtype.id"
                  :to="{
                    name: 'requested-documents-types-subtype',
                    params: {
                      lead_type_id: lead_type_id,
                      subtype_id: subtype.id,
                    },
                  }"
                  color="primary"
                  nav
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ subtype.description }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-list>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col>
          <router-view :key="$route.fullPath"></router-view>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import QueryMixin from "@/mixins/QueryMixin.vue";
import { indexByLeadType } from "@/services/subtypes/subtypes";
import i18n from "@/mixins/i18n";

export default {
  mixins: [QueryMixin, i18n],
  props: {
    lead_type_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      i18n_prefix: "settings",
    };
  },

  methods: {
    responseToData(response) {
      return response.data;
    },

    async getQuery() {
      return indexByLeadType(this.lead_type_id);
    },
  },

  created() {
    this.query();
  },
};
</script>
